import styled from 'styled-components';

import { Box } from '@aircall/tractor-v2';

export const ContentWrapper = styled(Box)`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;
